import axios from "axios";
import config from 'config';
import {  
  WRITE_LOG, 
  WRITE_IMPORTANTLOG,
  WRITE_SUPERVISORLOG,
  GET_LOG,
  GET_IMPORTANTLOG, 
  GET_SUPERVISORLOG } from "./logActionTypes";

const logActions = (dispatch) => {
  const fetchLog = async (sessionId) => {
    let notes = await _fetch(sessionId, "GetLog");
    dispatch({
      type: GET_LOG,
      payload: notes
    });
  };

  const fetchImportantLog = async (sessionId) => {
    let notes = await _fetch(sessionId, "GetImportantNotes");
    dispatch({
      type: GET_IMPORTANTLOG,
      payload: notes
    });
  };

  const fetchSupervisorLog = async (sessionId) => {
    let notes = await _fetch(sessionId, "GetSupervisorNotes");
    dispatch({
      type: GET_SUPERVISORLOG,
      payload: notes
    });
  };

  const write = async(sessionId, note) => {
    return new Promise(async (resolve,reject) => {
      await _write(sessionId, note, "log");
      dispatch({
        type: WRITE_LOG,
        payload: note
      })
      resolve();  
    });
  }

  const writeImportantLog = async(sessionId, note) => {
    return new Promise(async (resolve,reject) => {
      await _write(sessionId, note, "ImportantLog");
      dispatch({
        type: WRITE_IMPORTANTLOG,
        payload: note
      })
      resolve();  
    });
  }

  const writeSupervisorLog = async(sessionId, note) => {
    return new Promise(async (resolve,reject) => {
      await _write(sessionId, note, "SupervisorLog");
      dispatch({
        type: WRITE_SUPERVISORLOG,
        payload: note
      })
      resolve();  
    });
  }
  

  return { fetchLog, fetchImportantLog, fetchSupervisorLog, write, writeImportantLog, writeSupervisorLog  };
};

const _fetch = (sessionId, url) => {
  return new Promise((resolve, reject) => {
    axios({
      url: `${config.url}/api/Jobs/${url}?sessionId=${sessionId}`,
      method: "GET"
    }).then((response) => {
      resolve(response.data);
    }).catch((response) => {
      console.log("Error getting logs", response);
      reject();
    });
  });
}

const _write = (sessionId, note, noteType) => {
  return new Promise((resolve, reject) => {
    axios({
      url: `${config.url}/api/Jobs/${noteType}?sessionId=${sessionId}&note=${note}`,
      method: "POST"
    }).then((response) => {
      resolve(response.data);
    }).catch((response) => {
      console.log("Error getting logs", response);
      reject();
    });
  });
}

export default logActions;